import { useState, useEffect, useCallback } from "react";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";

export const useHeaderScroll = (isTabBarVisible = false, enabled = true) => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const [scrollPosition, setScrollPosition] = useState(window.scrollY);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  const handleScroll = useCallback(() => {
    const offset = isTabBarVisible ? 56 : 0;
    if (isMobileSize && window.scrollY >= offset) {
      const isScrollingUp = window.scrollY - scrollPosition < 0 || window.scrollY === 0;
      setIsHeaderVisible(isScrollingUp);
    } else if (isMobileSize && window.scrollY < offset && !isHeaderVisible) {
      setIsHeaderVisible(true);
    }
    setScrollPosition(window.scrollY);
  }, [scrollPosition, isMobileSize, isTabBarVisible]);

  useEffect(() => {
    if (!enabled) {
      setIsHeaderVisible(true);
      return;
    }

    setScrollPosition(window.scrollY);
    window.addEventListener("scroll", handleScroll, { passive: true });

    const handleOrientationChange = () => setIsHeaderVisible(true);
    window.screen?.orientation?.addEventListener("change", handleOrientationChange);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.screen?.orientation?.removeEventListener("change", handleOrientationChange);
    };
  }, [handleScroll, enabled]);

  return {
    isHeaderVisible,
  };
};
